import React, { useState } from 'react';
import { Settings, Percent, Mail, Globe, HelpCircle, ListOrdered, Shield, Headphones } from 'lucide-react';
import CommissionSettings from '../../components/admin/settings/CommissionSettings';
import EmailSettings from '../../components/admin/settings/EmailSettings';
import SiteSettings from '../../components/admin/settings/SiteSettings';
import AdminHelpSettings from '../../components/admin/settings/AdminHelpSettings';
import HowItWorksSettings from '../../components/admin/settings/HowItWorksSettings';
import SafetySettings from '../../components/admin/settings/SafetySettings';
import VendorSupportSettings from '../../components/admin/settings/VendorSupportSettings';

const AdminSettings = () => {
  const [activeTab, setActiveTab] = useState('commission');

  const tabs = [
    { id: 'commission', label: 'Commission', icon: Percent },
    { id: 'email', label: 'Email', icon: Mail },
    { id: 'site', label: 'Site Settings', icon: Globe },
    { id: 'how-it-works', label: 'How It Works', icon: ListOrdered },
    { id: 'safety', label: 'Safety', icon: Shield },
    { id: 'vendor-support', label: 'Vendors Support', icon: Headphones },
    { id: 'help', label: 'Help', icon: HelpCircle },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="p-6">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 flex items-center gap-3">
            <Settings className="w-8 h-8" />
            Settings
          </h1>
          <p className="mt-2 text-gray-600">Manage platform settings and configurations</p>
        </div>

        {/* Tabs Navigation */}
        <div className="mb-6 border-b border-gray-200">
          <nav className="flex space-x-8">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                    activeTab === tab.id
                      ? 'border-black text-black'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <div className="flex items-center gap-2">
                    <Icon className="w-4 h-4" />
                    {tab.label}
                  </div>
                </button>
              );
            })}
          </nav>
        </div>

        {/* Settings Sections */}
        {activeTab === 'commission' && <CommissionSettings />}
        {activeTab === 'email' && <EmailSettings />}
        {activeTab === 'site' && <SiteSettings />}
        {activeTab === 'how-it-works' && <HowItWorksSettings />}
        {activeTab === 'safety' && <SafetySettings />}
        {activeTab === 'vendor-support' && <VendorSupportSettings />}
        {activeTab === 'help' && <AdminHelpSettings />}
      </div>
    </div>
  );
};

export default AdminSettings;

